export enum Types {
	CONSULTAR_FICHA_CADASTRAL_REQUEST = '@DETRAN-CRV/CONSULTAR_FICHA_CADASTRAL_REQUEST',
	CONSULTAR_FICHA_CADASTRAL_SUCCESS = '@DETRAN-CRV/CONSULTAR_FICHA_CADASTRAL_SUCCESS',
	CONSULTAR_FICHA_CADASTRAL_FAILURE = '@DETRAN-CRV/CONSULTAR_FICHA_CADASTRAL_FAILURE',
	CONSULTAR_FICHA_CADASTRAL_CLEAR = '@DETRAN-CRV/CONSULTAR_FICHA_CADASTRAL_CLEAR',
}

export interface consultarFichaCadastral {
	status: number;
	data: ficha | null;
}

interface ficha {
	ficha: {
		anoFicha: number;
		chassi: string;
		codigoSSP: number;
		dataEmissaoDocumento: string;
		dataHoraExlcusao: string;
		dataInclusaoFicha: string;
		dataInclusaohistorico: string;
		municipio: {
			codigo: number;
			nome: string;
		};
		numeroFicha: number;
		opcao: string;
		placa: string;
		planilhaRenavam: string[];
		renavam: number;
		retornoBin: string;
		retornoConsistencia: string;
		status: string;
	};
}
